export default "__VITE_ASSET__BI6l_h4q__"